<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row class="mx-0 align-center">
          <v-autocomplete
            v-model="selectedProjects"
            :items="projectOptions"
            :loading="isLoading"
            label="Project"
            class="col-8 pl-0 pb-0 pr-4"
            multiple
            hide-details
            @blur="$emit('load-reviews', { entityIds: selectedProjects, statuses: selectedStatuses })"
          />
          <v-select
            label="Status"
            v-model="selectedStatuses"
            :items="STATUS_OPTIONS"
            :loading="isLoading"
            hide-details
            class="col-4 px-0 pb-0"
            multiple
            @change="$emit('load-reviews', { entityIds: selectedProjects, statuses: selectedStatuses })"
          />
          <!--          <v-btn-->
          <!--            v-if="suspiciousActivityReviews.length"-->
          <!--            class="ml-2"-->
          <!--            color="primary"-->
          <!--            @click="groupBy = groupBy === 'account_id' ? null : 'account_id'"-->
          <!--          >-->
          <!--            Group by {{ groupBy ? 'Review' : 'Account' }}-->
          <!--          </v-btn>-->
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <v-data-table
        height="calc(100vh - 190px)"
        :items="suspiciousActivityReviews"
        :headers="tableHeaders"
        :loading="isLoading"
        :group-by="groupBy"
        item-class="review-item"
      >
        <template #group.header="{ items, remove }">
          <td colspan="11">
            <strong>
              Account Info:
            </strong>
            ID: {{ items[0].account_id }},
            Login: {{ items[0].account.login }},
            Project: {{ projectNameById[items[0].entity_id] || `Project #${items[0].entity_id}` }},
            Created: {{ items[0].account.created }},
            Currency: {{ items[0].account.currency }},
            Country: {{ items[0].account.country }}

            <v-row class="mx-0 my-1 align-center" style="gap: 1rem;">
              <v-btn
                v-text="getIsAccessDenied(items[0].account, PERMISSION_DEPOSIT) ? 'Allow deposit' : 'Deny deposit'"
                :color="getIsAccessDenied(items[0].account, PERMISSION_DEPOSIT) ? 'success' : 'error'"
                small
                @click="onToggleAccessStatus(PERMISSION_DEPOSIT, items[0])"
              />
              <v-btn
                v-text="getIsAccessDenied(items[0].account, PERMISSION_WITHDRAW) ? 'Allow withdraw' : 'Deny withdraw'"
                :color="getIsAccessDenied(items[0].account, PERMISSION_WITHDRAW) ? 'success' : 'error'"
                small
                @click="onToggleAccessStatus(PERMISSION_WITHDRAW, items[0])"
              />
              <v-btn
                v-text="getIsAccessDenied(items[0].account, PERMISSION_FAST_WITHDRAW) ? 'Allow fast withdraw' : 'Deny fast withdraw'"
                :color="getIsAccessDenied(items[0].account, PERMISSION_FAST_WITHDRAW) ? 'success' : 'error'"
                small
                @click="onToggleAccessStatus(PERMISSION_FAST_WITHDRAW, items[0])"
              />
              <v-btn
                v-text="getIsAccessDenied(items[0].account, PERMISSION_GAME) ? 'Allow games' : 'Deny games'"
                :color="getIsAccessDenied(items[0].account, PERMISSION_GAME) ? 'success' : 'error'"
                small
                @click="onToggleAccessStatus(PERMISSION_GAME, items[0])"
              />
            </v-row>
          </td>
        </template>

        <template v-slot:item.account.login="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.account.login }}</a>
        </template>
        <template #item.entity_id="{value}">
          {{ projectNameById[value] || `Project #${value}` }}
        </template>
        <template #item.operator_comment="{ item }">
          <v-text-field
            v-model="item.operator_comment"
            :loading="isLoading"
            style="min-width: 18.5rem;"
            class="pb-1 pt-0"
            append-outer-icon="save"
            hide-details
            @click:append-outer="onUpdateComment(item)"
          />
        </template>
        <template #item.status="{ value, item }">
          <v-select
            class="pb-1 status-select"
            :value="value"
            :items="STATUS_OPTIONS"
            :loading="isLoading"
            dense
            hide-details
            @change="$emit('update-status', { review_id: item.suspicious_activity_review_id, status: $event })"
          />
        </template>
        <template #item.actions="{item}">

            <v-menu
                :close-on-content-click="false"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-card>
                    <v-card-text>
                        <v-switch
                            label="Deny deposit"
                            _success="!getIsAccessDenied(item.account, PERMISSION_DEPOSIT)"
                            _error="getIsAccessDenied(item.account, PERMISSION_DEPOSIT)"
                            v-model="item.account.access_limit[PERMISSION_DEPOSIT]"
                            @change="onToggleAccessStatus(PERMISSION_DEPOSIT, item)"
                            hide-details
                            class="my-1 py-0"
                        />
                        <v-switch
                            label="Deny withdraw"
                            _success="!getIsAccessDenied(item.account, PERMISSION_WITHDRAW)"
                            _error="getIsAccessDenied(item.account, PERMISSION_WITHDRAW)"
                            v-model="item.account.access_limit[PERMISSION_WITHDRAW]"
                            @change="onToggleAccessStatus(PERMISSION_WITHDRAW, item)"
                            hide-details
                            class="my-1 py-0"
                        />
                        <v-switch
                            label="Deny fast withdraw"
                            _success="!getIsAccessDenied(item.account, PERMISSION_FAST_WITHDRAW)"
                            _error="getIsAccessDenied(item.account, PERMISSION_FAST_WITHDRAW)"
                            v-model="item.account.access_limit[PERMISSION_FAST_WITHDRAW]"
                            @change="onToggleAccessStatus(PERMISSION_FAST_WITHDRAW, item)"
                            hide-details
                            class="my-1 py-0"
                        />
                        <v-switch
                            label="Deny games"
                            _success="!getIsAccessDenied(item.account, PERMISSION_GAME)"
                            _error="getIsAccessDenied(item.account, PERMISSION_GAME)"
                            v-model="item.account.access_limit[PERMISSION_GAME]"
                            @change="onToggleAccessStatus(PERMISSION_GAME, item)"
                            hide-details
                            class="my-1 py-0"
                        />
                    </v-card-text>
                </v-card>
            </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped lang="scss">
  .v-data-table {

    table {
      td {
        white-space: nowrap;
      }
    }

    .status-select {
      width: 105px;
    }

    .item-action {
      width: 310px;


      .v-input {
        zoom: 0.85;
      }
    }
  }
</style>

<script>
import {
    STATUS_NEW,
    STATUS_IN_REVIEW,
  STATUS_OPTIONS,
  PERMISSION_DEPOSIT,
  PERMISSION_FAST_WITHDRAW,
  PERMISSION_GAME,
  PERMISSION_WITHDRAW,
} from '../consts'

export default {
  props: {
    isLoading: Boolean,
    suspiciousActivityReviews: {
      type: Array,
      default: () => ([])
    },
    projectOptions: {
      type: Array,
      default: () => ([])
    },
  },

  data() {
    return {
        selectedStatuses: [
            STATUS_NEW,
            STATUS_IN_REVIEW,
        ],
      selectedProjects: [this.projectOptions[0].value],
      STATUS_OPTIONS,

      PERMISSION_DEPOSIT,
      PERMISSION_FAST_WITHDRAW,
      PERMISSION_GAME,
      PERMISSION_WITHDRAW,

      groupBy:  null, //'account_id',
    }
  },

  mounted() {
    this.$emit('load-reviews',  {entityIds: this.selectedProjects, statuses: this.selectedStatuses})
  },

  computed: {
    projectNameById() {
      return Object.fromEntries(this.projectOptions.map(({text, value}) => ([value, text])))
    },

    tableHeaders() {
      if (this.groupBy) {
        return [
          { text: 'Message', value: 'message', },
          { text: 'Operator', value: 'modified_by', },
          { text: 'Operator Comment', value: 'operator_comment' },
          { text: 'Status', value: 'status' },
          { text: 'Created', value: 'created' },
        ]
      } else {
        return [
            { text: 'Project', value: 'entity_id', class: 'nowrap' },
            { text: 'ID', value: 'account_id', class: 'nowrap' },
            { text: 'Login', value: 'account.login', class: 'nowrap' },
            { text: 'Message', value: 'message', class: 'nowrap' },
            { text: 'Operator', value: 'modified_by', class: 'nowrap' },
            { text: 'Operator Comment', value: 'operator_comment', class: 'nowrap' },
            { text: 'Status', value: 'status', class: 'nowrap' },
            { text: 'Registration', value: 'account.created', cellClass: 'nowrap', class: 'nowrap' },
            { text: 'Country', value: 'account.country', class: 'nowrap' },
            { text: 'Currency', value: 'account.currency', class: 'nowrap' },
            { text: 'Created', value: 'created', cellClass: 'nowrap', class: 'nowrap' },
            { text: '', value: 'actions', sortable: false, class: 'nowrap' },
        ]
      }
    }
  },

  methods: {
    getIsAccessDenied(account, key) {
      const permissionValue = account.access_limit?.[key]

      return permissionValue === true
    },

    onToggleAccessStatus(permissionKey, review) {
      this.$root.$confirm(
        'Confirm',
        `Are you sure you want to toggle the ${permissionKey} permission for account ${review.account.login}?`
      ).then(yes => {
        if (!yes) {
          review.account.access_limit[permissionKey] = !review.account.access_limit?.[permissionKey]
          return
        }

        this.$emit('toggle-permission', permissionKey, review)
      })
    },

    onUpdateComment(review) {
      this.$root.$confirm(
        'Confirm',
        `Are you sure you want to update the comment?`
      ).then(yes => {
        if (!yes) {
          return
        }

        this.$emit('update-comment', review)
      })
    }
  }
}
</script>
